<template>
  <div>
    <Loader v-if="loading" />
    <b-row v-else>
      <b-col cols="12" md="4">
        <div class="card mb-3 p-3">
          <BaseText :maxlength="2000" :value="model.price" @input="model.price = $event" title="قیمت" placeholder="قیمت (تومان) " />
          <BaseText :maxlength="2000" :value="model.discount" @input="model.discount = $event" title="قیمت با تخفیف" placeholder="قیمت با تخفیف (تومان) " class="mt-2" />
        </div>

        <div class="card mb-3 p-3">
          <div class="section-title">وضعیت دوره</div>
          <Radio :componentData="cuorseTypes" :value="model.courseType" @input="model.courseType = $event" />
        </div>
        <div class="card mb-3 p-3">
          <b-form-checkbox v-model="model.isRecommendedForDashboard" class="pt-2">
            <div class="mx-1">دوره منتخب</div>
          </b-form-checkbox>
          <BaseText :maxlength="2000" v-model="model.orderForDashboard" title="ترتیب دوره منتخب" placeholder="ترتیب دوره منتخب" class="mt-2" />
        </div>
        <div class="card mb-3 p-3">
          <div class="section-title">موضوع</div>
          <Radio :componentData="courseCategories" :value="model.courseCategoryId" @input="model.courseCategoryId = $event" />
        </div>
        <div class="card p-3 mt-3 my-auto d-flex flex-column justify-content-between">
          <div>
            <b-form-checkbox v-model="model.isDisplayable" class="pt-2">
              <div class="mx-1">نمایش در صفحه خانه</div>
            </b-form-checkbox>
            <b-form-checkbox v-model="model.allowSnapPay" class="pt-2">
              <div class="mx-1">پرداخت با اسنپ‌پی</div>
            </b-form-checkbox>
          </div>

          <div>
            <b-form-checkbox v-model="model.isEnable" class="pt-2">
              <div class="mx-1">نمایش دوره</div>
            </b-form-checkbox>
          </div>

          <div class="d-flex justify-content-between">
            <b-form-checkbox v-model="model.isRecommended" class="pt-2">
              <div class="mx-1">دوره پیشنهادی</div>
            </b-form-checkbox>
            <b-form-checkbox v-model="model.isRecommendedForJob" class="pt-2">
              <div class="mx-1">پیشنهاد دوره در شغل ها</div>
            </b-form-checkbox>

            <b-button @click="$bvModal.show('deleteModal')" variant="outline-secondary">
              <i class="far fa-times-circle"></i>
              <span class="ms-2">حذف دوره</span>
            </b-button>
          </div>
        </div>

        <div class="card p-3 mt-3">
          <strong class="d-block my-2">ترتیب دوره های پیشنهادی</strong>
          <BaseText :maxlength="2000" v-model="model.order" title="ترتیب دوره ها در صفحات سامانه" placeholder="ترتیب دوره ها در صفحات سامانه" class="mt-2" />
          <BaseText :maxlength="2000" v-model="model.orderForJob" title="ترتیب دوره ها در صفحات شغل ها" placeholder="ترتیب دوره ها در صفحات شغل ها" class="mt-2" />
        </div>
        <div class="inner__style mt-3">
          <div
            v-if="images.length === 0"
            class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center"
            @click="(event) => (images.length === 2 ? event.preventDefault() : $refs.fileInput.click())"
          >
            <div>
              <i :class="['fas fa-cloud-upload-alt __icon', { 'fas fa-spinner fa-spin': cropperLoading }]"></i>
              <div class="upload-text-size">عکس دوره را انتخاب کنید</div>
            </div>
          </div>
          <div v-else class="grand-parent">
            <div class="uploaded-photo-main">
              <div v-for="(image, index) in images" :key="index" class="uploaded-photo">
                <div class="remove-icon" @click="removeImage({ index, image })">
                  <i class="fa fa-times"></i>
                </div>
                <img class="previewImage" @click="changeSelectedImage(image)" :src="image" :class="{ selected: model.selectedImage == image }" />
              </div>
              <div v-if="images.length < 2" @click="() => $refs.fileInput.click()" class="uploaded-photo addNewImageIconContainer">
                <i :class="['fa fa-plus', { 'fas fa-spinner fa-spin': cropperLoading }]"></i>
              </div>
            </div>
          </div>
          <div class="my-3">
            <TextAreaInput
              :maxlength="100"
              :value="model.selectedImageAlternateText"
              @input="model.selectedImageAlternateText = $event"
              title="متن جایگزین 1"
              placeholder="متن جایگزین"
              rows="2"
            />
          </div>
          <div class="my-3">
            <TextAreaInput rows="2" :maxlength="100" :value="model.imageAlternateText" @input="model.imageAlternateText = $event" title="متن جایگزین 2" placeholder="متن جایگزین" />
          </div>
          <input style="display: none" type="file" accept="image/*" @change="onFileSelected" ref="fileInput" />
        </div>
        <div class="inner__style my-3">
          <div
            v-if="!model.video"
            class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center"
            @click="
              $bvModal.show('videoModal')
              cropperLoading = false
            "
          >
            <div>
              <i class="fas fa-cloud-upload-alt icon-size"></i>
              <div class="upload-text-size">ویدئو تبلیغاتی دوره را انتخاب کنید</div>
            </div>
          </div>
          <div v-else class="grand-parent">
            <div class="upload-video-parent">
              <div class="uploaded-video">
                <div
                  class="remove-icon"
                  @click="
                    model.video = ''
                    uploadedvideo = ''
                  "
                >
                  <i class="fa fa-times"></i>
                </div>
                <video class="previewVideo" :src="model.video" />
              </div>
            </div>
          </div>
          <div class="my-3">
            <BaseText :maxlength="2000" :value="model.videoName" @input="model.videoName = $event" title="نام ویدئو" placeholder="نام ویدئو" />
          </div>
        </div>

        <div class="inner__style my-3">
          <div
            v-if="!model.summaryVideo"
            class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center"
            @click="
              $bvModal.show('videoSummaryModal')
              cropperLoading = false
            "
          >
            <div>
              <i class="fas fa-cloud-upload-alt icon-size"></i>
              <div class="upload-text-size">خلاصه ویدئو دوره را انتخاب کنید</div>
            </div>
          </div>
          <div v-else class="grand-parent">
            <div class="upload-video-parent">
              <div class="uploaded-video">
                <div
                  class="remove-icon"
                  @click="
                    model.summaryVideo = ''
                    uploadedsummaryvideo = ''
                  "
                >
                  <i class="fa fa-times"></i>
                </div>
                <video class="previewVideo" :src="model.summaryVideo" />
              </div>
            </div>
          </div>
          <div class="my-3">
            <BaseText :maxlength="2000" :value="model.summaryVideoName" @input="model.summaryVideoName = $event" title="نام ویدئو" placeholder="نام ویدئو" />
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="8">
        <div class="card">
          <Section title="اطلاعات دوره">
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.name" @input="model.name = $event" title="عنوان دوره" placeholder="عنوان دوره" />
            </div>

            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.smsTitle" @input="model.smsTitle = $event" title="عنوان پیامک" placeholder="عنوان پیامک" />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.shortDescription" @input="model.shortDescription = $event" title="توضیحات کوتاه" placeholder="توضیحات کوتاه" />
            </div>
            <div class="my-3">
              <EditorInput :value="model.fullDescription" @input="model.fullDescription = $event" title="توضیحات کلی" textAreaClass="align-items-center" />
            </div>
          </Section>
        </div>
        <div class="card">
          <div class="date-header">اطلاعات دوره</div>
          <Section v-if="!model.courseType || model.courseType === 0 || model.courseType === 1" title="تاریخ دوره">
            <div>
              <DateTimeOffset range :value="dateRange" @input="dateRange = $event" title="تاریخ دوره" placeholder="تاریخ دوره" :hasDefaultDate="false" :key="dateRender" />
            </div>
          </Section>
          <Section v-if="(!model.courseType || model.courseType === 2) && model.courseType !== 0" title="تاریخ انتشار">
            <div>
              <DateTimeOffset
                :value="model.releaseDatetime"
                @input="model.releaseDatetime = $event"
                title="تاریخ انتشار"
                placeholder="تاریخ انتشار"
                :hasDefaultDate="false"
                :key="dateRender"
              />
            </div>
          </Section>
          <Section>
            <div>
              <DateTimeOffset :value="model.hour" @input="model.hour = $event" title="ساعت شروع دوره" placeholder="ساعت شروع دوره" :hasDefaultDate="false" type="time" />
            </div>
          </Section>
          <Section title="مدت دوره">
            <div>
              <BaseText :maxlength="2000" :value="model.courseDuration" @input="model.courseDuration = $event" title="مدت دوره" placeholder="مدت دوره" />
            </div>
          </Section>
          <Section title="مدرک">
            <ComboBox
              :searchedData="courseCertificates"
              title="اعطا گواهی معتبر"
              placeholder="اعطا گواهی معتبر"
              :selectedValue="selectedCertificate"
              @select="fillSelectedCertificate"
              :inputStyle="comboStyle"
            />
          </Section>
          <Section title="وضعیت">
            <div>
              <BaseText :maxlength="2000" :value="model.holdingType" @input="model.holdingType = $event" title="برگزاری به صورت" placeholder="برگزاری به صورت" />
            </div>
          </Section>
          <Section title="ظرفیت">
            <div>
              <CountInput :value="model.capacity" @input="model.capacity = $event" title="ظرفیت" placeholder="ظرفیت" />
            </div>
          </Section>
          <Section title="مهلت ثبت نام">
            <div>
              <DateTimeOffset
                :value="model.deadlineDate"
                @input="model.deadlineDate = $event"
                title="مهلت ثبت نام"
                placeholder="مهلت ثبت نام"
                :hasDefaultDate="false"
                :key="dateRender"
              />
            </div>
          </Section>
          <Section title="توضیحات تکمیلی">
            <div>
              <EditorInput :value="model.extraDescription" @input="model.extraDescription = $event" title="توضیحات تکمیلی" :hasImage="false" textAreaClass="align-items-center" />
            </div>
          </Section>
        </div>
        <div class="card">
          <Section title="اساتید دوره">
            <MultiSelectSearch :value="selectedTeachers" @input="addTeacher" :items="courseTeachers" title="اساتید" isTag />
          </Section>
        </div>
        <div class="card">
          <Section title="منتورهای دوره">
            <MultiSelectSearch :value="selectedMentors" @input="addMentor" :items="courseMentors" title="منتورهای دوره" isTag />
          </Section>
        </div>
        <div class="card">
          <Section title="تنظیمات سئو">
            <div class="my-3">
              <Tags title="کلیدواژه" v-model="model.seoKeyword" classes="tags" placeholder="کلیدواژه" />
            </div>
            <div class="my-3">
              <TextAreaInput :value="model.seoDescription" @input="model.seoDescription = $event" title="توضیحات" textAreaClass="align-items-center" />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.seoUrlDescription" @input="model.seoUrlDescription = $event" title="متن URL" placeholder="متن URL" />
            </div>
          </Section>
        </div>
      </b-col>
    </b-row>
    <div class="card p-3 d-flex flex-row justify-content-end">
      <b-button @click="$router.push('/list/courses')">انصراف</b-button>
      <b-button variant="primary ms-2 px-5" @click="addCourse">ثبت</b-button>
    </div>
    <b-modal id="deleteModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4 text-center">
          <img src="@/assets/images/checked1.svg" />
        </div>
        <div class="error-title text-center">آیا از حذف دوره اطمینان دارید؟</div>
        <div class="mt-3 float-right w-100">
          <div class="d-flex align-items-center justify-content-center">
            <b-button class="col-6" variant="secondary" block @click="$bvModal.hide('deleteModal')">خیر</b-button>
            <b-button class="ms-2 col-6" variant="primary" block @click="deleteCourse">بله</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <Toast :title="message" :error="error" :showToast="message !== ''" />
    <b-modal id="videoModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title no-close-on-backdrop @close="closeVideoUpload('video')">
      <template #modal-title>انتخاب ویدئو</template>
      <div class="p-3">
        <VideoUpload
          @preload="preload($event, 'video')"
          :percent="percentCompleted"
          :loading="cropperLoading"
          @videoSourceChanged="uploadVideo($event, 'video')"
          @close="closeVideoUpload('video')"
        />
      </div>
    </b-modal>
    <b-modal
      id="videoSummaryModal"
      no-close-on-esc
      hide-footer
      centered
      size="md"
      header-close-variant="dark"
      cancel-title
      no-close-on-backdrop
      @close="closeVideoUpload('summaryVideo')"
    >
      <template #modal-title>انتخاب ویدئو</template>
      <div class="p-3">
        <VideoUpload
          @preload="preload($event, 'summaryVideo')"
          :percent="percentCompleted"
          :loading="cropperLoading"
          @videoSourceChanged="uploadVideo($event, 'summaryvideo')"
          @close="closeVideoUpload('summaryVideo')"
        />
      </div>
    </b-modal>
  </div>
</template>
<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
import fileMannager from '../../../services/file'
import dadbanCoursesProvider from '../../../services/dadban/course'
import Toast from '../../common/Toast.vue'
import Loader from '../../widgets/loader.vue'
import Section from '../../common/form/Section.vue'
import Radio from '../../common/form/formModules/Radio.vue'
import DateTimeOffset from '../../common/form/formModules/DateTimeOffset.vue'
import MultiSelectSearch from '../../common/form/MultiSelectSearch.vue'
import VideoUpload from '../../common/form/VideoUpload.vue'
import ComboBox from '../../common/form/formModules/ComboBox.vue'
import EditorInput from '../../common/form/formModules/editorInput.vue'
import Tags from '../../common/form/formModules/Tags.vue'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'
import CountInput from '../../common/form/CountInput.vue'
import axios from 'axios'

let controller = new AbortController()
export default {
  name: 'AddCourse',
  components: { Toast, Loader, Section, BaseText, Radio, DateTimeOffset, MultiSelectSearch, VideoUpload, ComboBox, EditorInput, Tags, TextAreaInput, CountInput },
  props: {
    create: {
      type: Boolean,
      default: false,
    },
    update: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        name: '',
        smsTitle: '',
        courseCategoryId: '',
        courseCertificateId: '',
        shortDescription: '',
        extraDescription: '',
        fullDescription: '',
        summaryVideoName: '',
        releaseDatetime: '',
        summaryVideo: '',
        selectedImage: '',
        image: '',
        hour: '',
        video: '',
        videoName: '',
        hasCertificate: false,
        isEnable: true,
        isRecommended: false,
        order: undefined,
        isDisplayable: true,
        courseType: '',
        price: '',
        discount: '',
        releaseDate: '',
        startDate: '',
        endDate: '',
        isFree: false,
        courseDuration: '',

        holdingType: '',
        teacherIds: [],
        mentorIds: [],
        seoKeyword: [],
        seoDescription: '',
        seoUrlDescription: '',
        allowSnapPay: false,
        imageAlternateText: '',
        imageDescription: '',
        selectedImageAlternateText: '',
        selectedImageDescription: '',
        deadlineDate: '',
        capacity: '',
        isRecommendedForJob: false,
        orderForJob: '',
        isRecommendedForDashboard: false,
        orderForDashboard: '',
      },
      comboStyle: 'color: #495057',
      selectedTeachers: [],
      selectedMentors: [],
      selectedCertificate: '',
      cuorseTypes: [
        {
          value: 'حضوری',
          key: 0,
        },
        {
          value: 'آنلاین',
          key: 1,
        },
        {
          value: 'آفلاین',
          key: 2,
        },
      ],
      courseCategories: [],
      courseTeachers: [],
      courseMentors: [],
      courseCertificates: [],
      dateRange: [],
      images: [],
      message: '',
      cropperLoading: false,
      submit: false,
      error: false,
      loading: false,
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت دوره', active: true },
      ],
      imageCrop: { width: 400, height: 200 },
      updateForm: false,
      dateRender: true,
      percentCompleted: 0,
      uploadedvideo: '',
      uploadedsummaryvideo: '',
    }
  },
  watch: {
    'model.deadlineDate'(c) {
      if (c && !c.includes('T')) {
        this.model.deadlineDate = this.model.deadlineDate.replaceAll('/', '-') + 'T00:00:00.000Z'
      }
    },
    'model.releaseDatetime'(c) {
      if (c && !c.includes('T')) {
        this.model.releaseDatetime = this.model.releaseDatetime.replaceAll('/', '-') + 'T00:00:00.000Z'
      }
    },
    'model.price'(c) {
      if (c && !this.submit) {
        this.model.price = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    'model.discount'(c) {
      if (c && !this.submit) {
        this.model.discount = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    'images.length'(c) {
      const selected = this.images[0]
      if (c <= 1) {
        if (!this.model.selectedImage && this.images.length) {
          this.model.selectedImage = selected
        }
      }
    },
    dateRange(c) {
      if (c.length > 1) {
        const start = c[0]
        const end = c[1]
        this.model.startDate = start.replaceAll('/', '-') + 'T00:00:00.000Z'
        this.model.endDate = end.replaceAll('/', '-') + 'T00:00:00.000Z'
      }

      if (c.length === 1) {
        this.model.startDate = c[0].replaceAll('/', '-') + 'T00:00:00.000Z'
      }
      if (!c) {
        this.model.startDate = null
        this.model.endDate = null
      }
    },
  },
  async mounted() {
    await this.fetchCourseInputs()
    if (this.update) {
      this.fetchCourse(+this.$route.params.courseId)
    }
    this.loading = false
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 10)
    setTimeout(() => {
      this.dateRender = false
    }, 3000)
  },
  methods: {
    onFileSelected(event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        const img = new Image()
        img.src = e.target.result
        this.uploadImage(e.target.result)
      }

      reader.readAsDataURL(file)
    },
    fillSelectedCertificate(e) {
      if (!e) {
        this.model.courseCertificateId = null
        this.model.hasCertificate = false
        return false
      }
      this.model.courseCertificateId = this.courseCertificates.find((item) => item.value === e).key
      this.model.hasCertificate = true
    },
    async addCourse() {
      this.loading = true
      this.model.image = this.images.find((item) => item !== this.model.selectedImage)
      this.model.isFree = false
      if (!this.model.price && !this.model.discount) {
        this.model.isFree = true
      }
      if (+this.model.price === 0 && +this.model.discount === 0) {
        this.model.isFree = true
      }
      if (this.dateRange.length === 1) {
        this.model.endDate = this.model.startDate
      }
      this.model.video = this.uploadedvideo
      this.model.summaryVideo = this.uploadedsummaryvideo
      this.model.teacherIds.forEach((item, i) => {
        item.order = i
      })

      if (!this.model.courseType || this.model.courseType === 0 || this.model.courseType === 1) {
        this.model.releaseDatetime = ''
      }

      if ((!this.model.courseType || this.model.courseType === 2) && this.model.courseType !== 0) {
        this.dateRange = []
        this.model.startDate = ''
        this.model.endDate = ''
      }
      try {
        if (this.update) {
          await this.checkData()
          const req = await dadbanCoursesProvider.updateCourse({
            ...this.model,
            order: Number(this.model.order),
            orderForJob: Number(this.model.orderForJob),
            orderForDashboard: Number(this.model.orderForDashboard),
          })
          if (req.status === 200) {
            this.$emit('update', !this.updateForm)
            this.loading = false
          } else {
            this.error = true
            this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
          }
          return false
        }
        if (!this.model.price && !this.model.discount) {
          this.model.isFree = true
          this.model.price = 0
          this.model.discount = 0
        }
        await this.checkData()
        const req = await dadbanCoursesProvider.addCourse({
          ...this.model,
          order: Number(this.model.order),
          orderForDashboard: this.model.isRecommendedForDashboard ? Number(this.model.orderForDashboard) : null,
        })
        if (req.status === 200) {
          this.$router.push('/list/courses/detail/' + req.data.data)
        } else {
          this.error = true
          this.loading = false
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async fetchCourse() {
      this.loading = true
      try {
        if (this.update) {
          const req2 = await dadbanCoursesProvider.getCourse(+this.$route.params.courseId)
          this.model = req2.data.data.output

          if (this.model.selectedImage) {
            this.images.push(this.model.selectedImage)
          }
          if (this.model.image) {
            this.images.push(this.model.image)
          }
          this.model.price = this.model.price.toString()
          this.model.discount = this.model.discount.toString()
          this.model.teacherIds = this.model.teachers.map((item, i) => {
            return { id: item.id, fullName: item.fullName, order: i }
          })
          this.model.mentorIds = this.model.mentors.map((item) => {
            return item.id
          })
          if (this.model.startDate) {
            this.dateRange[0] = this.model.startDate.slice(0, 10).replaceAll('-', '/')
          }
          if (this.model.endDate) {
            this.dateRange[1] = this.model.endDate.slice(0, 10).replaceAll('-', '/')
          }
          // this.dateRange = [this.model.startDate.slice(0, 10).replaceAll('-', '/') || '', this.model.endDate.slice(0, 10).replaceAll('-', '/') || '']
          this.model.teachers.forEach((item) => {
            const find = this.model.teacherIds.find((el) => el.id == item.id).fullName
            this.selectedTeachers.push(find)
            // if (this.model.teacherIds.includes(item.id)) {
            // }
          })
          this.model.teacherIds = this.model.teacherIds.sort((a, b) => {
            return b.order - a.order
          })
          this.model.mentors.forEach((item) => {
            if (this.model.mentorIds.includes(item.id)) {
              this.selectedMentors.push(item.fullName)
            }
          })
          this.courseCertificates.filter((item) => {
            if (item.key === this.model.courseCertificateId) {
              this.selectedCertificate = item.value
            }
          })
          this.uploadedvideo = this.model.video
          this.uploadedsummaryvideo = this.model.summaryVideo
          delete this.model.teachers
          delete this.model.mentors
        }

        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async fetchCourseInputs() {
      this.loading = true
      const req = await dadbanCoursesProvider.getInputs()
      req.data.data.output.courseCategories.forEach((item) => {
        this.courseCategories.push({ value: item.title, key: item.id })
      })
      req.data.data.output.courseTeachers.forEach((item) => {
        this.courseTeachers.push({ value: item.fullName, key: item.id })
      })
      req.data.data.output.courseMentors.forEach((item) => {
        this.courseMentors.push({ value: item.fullName, key: item.id })
      })
      // this.courseCertificates = req.data.data.output.courseCertificates
      req.data.data.output.courseCertificates.forEach((item) => {
        this.courseCertificates.push({ value: item.name, key: item.id })
      })
    },
    async uploadImage(e) {
      this.cropperLoading = true
      const req = await fileMannager.addImage({
        base64image: e,
      })
      this.images.push(req.data.data.downloadUrl)
      this.cropperLoading = false
    },
    removeImage(payload) {
      this.images.splice(payload.index, 1)
      if (payload.image === this.model.image) {
        this.model.image = ''
      }
      if (payload.image === this.model.selectedImage) {
        this.model.selectedImage = ''
      }
      this.changeSelectedImage(payload.image)
    },
    async uploadVideo(e, item) {
      try {
        this.cropperLoading = true
        const req = await axios.post('FileManager/api/File/AddFiles', e, {
          onUploadProgress: (progressEvent) => {
            this.percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          },
          signal: controller.signal,
        })
        this['uploaded' + item] = req.data.data[0].downloadUrl

        setTimeout(() => {
          this.percentCompleted = 0
          this.$bvModal.hide('videoModal')
          this.$bvModal.hide('videoSummaryModal')
        }, 1000)
      } catch (error) {
        this.cropperLoading = false
      }
      this.cropperLoading = false
    },
    closeVideoUpload(item) {
      this.$bvModal.hide('videoModal')
      this.$bvModal.hide('videoSummaryModal')
      controller.abort()
      controller = new AbortController()
      this.percentCompleted = 0
      this.model[item] = ''
      this.model[item + 'Name'] = ''
    },
    preload(e, item) {
      this.model[item] = e
    },
    async deleteCourse() {
      this.loading = true
      try {
        const req = await dadbanCoursesProvider.deleteCourse(+this.$route.params.courseId)
        this.$bvModal.hide('deleteModal')
        if (req.status === 200) {
          this.$router.push('/list/courses' + localStorage.getItem('query'))
        } else {
          this.error = true
          this.loading = false
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    addTeacher(teachers) {
      this.model.teacherIds = []
      teachers.forEach((item, i) => {
        if (!this.model.teacherIds.includes(item.key)) {
          this.model.teacherIds.push({ id: item.key, fullName: item.value })
        }
      })
    },
    addMentor(mentors) {
      this.model.mentorIds = []
      mentors.forEach((item) => {
        if (!this.model.mentorIds.includes(item.key)) {
          this.model.mentorIds.push(item.key)
        }
      })
    },
    addCertificate(e) {
      this.model.courseCertificateId = e.key
    },
    checkData() {
      this.submit = true
      for (const key in this.model) {
        if (this.model[key] === '' || this.model[key] === undefined || this.model[key] === null) {
          delete this.model[key]
        }
      }
      if (this.model.courseType === '' || this.model.courseType === undefined) {
        return false
      }
      if (this.model.price && typeof this.model.price === 'string') {
        this.model.price = this.model.price.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.price = +this.model.price
      }
      if (this.model.discount && typeof this.model.discount === 'string') {
        this.model.discount = this.model.discount.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.discount = +this.model.discount
      }
    },
    changeSelectedImage(image) {
      if (this.model.selectedImage !== image) {
        this.model.selectedImage = image
        const imageDescription = this.model.selectedImageDescription
        const imageAlternateText = this.model.selectedImageAlternateText
        this.model.selectedImageAlternateText = this.model.imageAlternateText
        this.model.selectedImageDescription = this.model.imageDescription
        this.model.imageDescription = imageDescription
        this.model.imageAlternateText = imageAlternateText
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.image {
  border-radius: 100%;
  width: 200px;
  height: 200px;
  margin: auto;
}

.tags {
  ::v-deep .badge-secondary {
    background: #dde3ff !important;
    font-size: 14px !important;
    color: #556be6 !important;
    margin: 2px;
    button {
      color: #556be6;
      background: #dde3ff;
    }
  }
}

.inner__style {
  background-color: white;
  padding: 23px;
}

.uploaded-photo-main {
  display: flex;
  flex-wrap: wrap;
}
.uploaded-photo {
  height: 120px;
  width: 160px;
  position: relative;
  margin-left: 10px;
  margin-bottom: 10px;
  img {
    width: 100%;
    height: 100%;
  }
}
.uploaded-video {
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}
.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  z-index: 1;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
  }
}
.upload-text-size {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
}
.grand-parent {
  padding: 20px;
  border: 2px dashed #ced4da;
  justify-content: right;
  display: flex;
  align-items: right;
  position: relative;
}
.activeImageClass {
  border: 3px solid #556ee6;
  border-radius: 5px;
}
.remove-field-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  i {
    color: #ff4861;
  }
}
.previewImage {
  border-radius: 4px;
}
.previewVideo {
  border-radius: 4px;
  width: 100%;
}

.checkbox-margin {
  margin-right: 8px;
}

.section-title {
  font-size: 16px;
}
::v-deep .custom-control-label {
  margin-right: 10px !important;
}

::v-deep .custom-control-input {
  border: 1px solid #556ee6 !important;
}

::v-deep .text-muted {
  display: none;
}

.date-header {
  font-size: 17px;
  margin: 16px;
}

.selected {
  border: 3px solid #556be6;
}

.upload-video-parent {
  width: 100%;
}

::v-deep .b-form-tags-button {
  display: none;
}

.__icon {
  display: block;
  color: #74788d;
  font-size: 45px;
  text-align: center;
}
</style>
